"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginNotificationsReducer = void 0;
var _snackbarActions = require("../../actions/snackbarActions");
var _actions = require("../actions");
var _dateHelper = require("../../../helpers/dateHelper");
var initialState = localStorage.getItem('marginNotifications') ? JSON.parse(localStorage.getItem('marginNotifications')) : [];
var snackIds = ['MarginOrderLiquidation', 'MarginCall', 'MarginPositionLiquidation', 'MarginCancelOrderAccountLiquidation'];
var marginNotificationsReducer = exports.marginNotificationsReducer = function marginNotificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _snackbarActions.ADD_SNACK:
      if (snackIds.includes(payload.id) && !state.some(function (item) {
        return item.id === getUniqueKey(payload);
      })) {
        var dateTime = new Date(payload.uniqueId);
        var formattedDateTime = (0, _dateHelper.formatDate)(dateTime, 'HH:mm - M/D/YYYY');
        return state.concat({
          id: getUniqueKey(payload),
          type: payload.id,
          data: payload.textVars,
          dateTime: formattedDateTime
        });
      }
      return state;
    case _actions.DISMISS_MARGIN_NOTIFICATION:
      return state.filter(function (item) {
        return item.id !== payload;
      });
    default:
      return state;
  }
};
function getUniqueKey(snack) {
  switch (snack.id) {
    case 'MarginOrderLiquidation':
      return "MarginOrderLiquidation-".concat(snack.textVars.InstrumentSymbol, "-").concat(snack.textVars.Side);
    case 'MarginPositionLiquidation':
      return "MarginPositionLiquidation-".concat(snack.textVars.PositionId);
    case 'MarginCancelOrderAccountLiquidation':
      return "MarginCancelOrderAccountLiquidation-".concat(snack.textVars.OrderId);
    case 'MarginCall':
      return "MarginCall-".concat(snack.uniqueId);
    default:
      return snack.id;
  }
}